module.exports = __webpack_public_path__ + "assets/img/630100.ebca1a4a.png";